export default __webpack_public_path__ + "static/media/Polygon.85fd5c21.svg";